import "#/legacy/namespaces.js";
DoctorFinder.Models.AppointmentGrid = class AppointmentGrid extends Backbone.Model {
  defaults() {
    return {
      previous: null,
      next: null,
      dates: [],
    };
  }
};
